class Station {
  constructor(title, latitude, longitude, code, zoneId, geographicalTypeId) {
    this.title = title;
    this.latitude = latitude;
    this.longitude = longitude;
    this.code = code;
    this.zoneId = zoneId;
    this.geographicalTypeId = geographicalTypeId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allStations: [],
      allStationsForOther: [],
      station: new Station('', null, null, null, '', null),
      stationPaginationList: [],
    };
  },
  methods: {
    getListOfStationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllStations').then(() => {
        if (this.$store.state.stationModule.successFlag) {
          // this.allStationsForOther = this.$store.state.stationModule.allStations;
          const stations = this.$store.state.stationModule.allStations || [];

          this.allStationsForOther = stations.map(item => ({
            ...item,
            titleCode: `${item.title} - ${item.code}`
          }));
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfStationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfStationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllStations: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllStations').then(() => {
        if (this.$store.state.stationModule.successFlag) {
          // this.allStations = this.$store.state.stationModule.allStations;
          const stations = this.$store.state.stationModule.allStations || [];

          this.allStations = stations.map(item => ({
            ...item,
            titleCode: `${item.title} - ${item.code}`
          }));
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllStations();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllStations();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfStationsWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getStationsWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          title: this.searchText,
          code: this.searchCode,
          zoneId: this.searchZoneId,
        })
        .then(() => {
          if (this.$store.state.stationModule.successFlag) {
            this.stationPaginationList = [];
            let temp = this.$store.state.stationModule.stations;
            for (let i = 0; i < temp.length; i++) {
              this.stationPaginationList.push({
                counter: i + 1,
                title: temp[i].title ? temp[i].title : '-',
                city: temp[i].zone && temp[i].zone.city ? temp[i].zone.city.title : '-',
                code: temp[i].code ? temp[i].code : '-',
                address: temp[i].address ? temp[i].address : '-',
                zone: temp[i].zone ? temp[i].zone.title : '-',
                id: temp[i].id,
                geographicalTypeTitle: temp[i]?.geographicalType?.title,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.stationModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.stationModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.stationModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.stationModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfStationsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.stationModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfStationsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addStationFunction: function () {
      if (!this.station.title) {
        this.snackText = 'عنوان پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.station.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.station.code) {
        this.snackText = 'کد پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.station.zoneId) {
        this.snackText = 'ناحیه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (
        this.station.geographicalTypeId === null ||
        this.station.geographicalTypeId === undefined
      ) {
        this.snackText = 'نوع پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      if (this.position && this.position.lat) {
        this.station.latitude = this.position.lat;
        this.station.longitude = this.position.lng;
      }
      this.$store.dispatch('addStation', this.station).then(() => {
        if (this.$store.state.stationModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' پایگاه با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.station = new Station('', null, null, null, '', null);
          this.cityId = null;
          this.position = null;
          this.allZonesForOther = [];
          this.getListOfStationsWithPagination();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addStationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addStationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getStationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getStation', id).then(() => {
        if (this.$store.state.stationModule.successFlag) {
          let temp = this.$store.state.stationModule.station;
          this.station.id = temp.id;
          this.station.title = temp.title;
          this.station.code = temp.code;
          this.station.geographicalTypeId = temp.geographicalType?.id;
          this.station.zoneId = temp.zone.id;
          this.cityId = temp.zone.city.id;
          if (temp.latitude) {
            this.station.latitude = temp.latitude;
            this.station.longitude = temp.longitude;
            this.position = { lat: temp.latitude, lng: temp.longitude };

            this.$refs.modalmap.mapObject.flyTo([temp.latitude, temp.longitude], 12);
          }
          // this.getCityGeoLocation();
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getStationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getStationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editStationFunction: function () {
      if (!this.station.title) {
        this.snackText = 'عنوان پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.station.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.station.code) {
        this.snackText = 'کد پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.station.zoneId) {
        this.snackText = 'ناحیه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (
        this.station.geographicalTypeId === null ||
        this.station.geographicalTypeId === undefined
      ) {
        this.snackText = 'نوع پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      if (this.position && this.position.lat) {
        this.station.latitude = this.position.lat;
        this.station.longitude = this.position.lng;
      }
      this.$store.dispatch('editStation', this.station).then(() => {
        if (this.$store.state.stationModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfStationsWithPagination();
          this.snackText = ' پایگاه با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.cityId = null;
          this.station = new Station('', null, null, null, '', null);
          this.position = null;
          this.allZonesForOther = [];
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editStationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editStationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteStationFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteStation', this.stationId).then(() => {
        if (this.$store.state.stationModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfStationsWithPagination();
          this.snackText = ' پایگاه با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.stationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteStationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.stationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteStationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.stationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
  computed: {
    allStationsWithoutCode() {
      return [...this.allStationsForOther].map(({ title, code, id }) => {
        return {
          id,
          titleCode: `${title} (${code})`,
        };
      });
    },
  },
};
